import { Container, Anchor, Alert, Title } from "@mantine/core";
import { IconMail } from "@tabler/icons-react";

const Contact = () => (
  <Container size="xs">
    <Title>Contact</Title>
    <Alert
      mt="xl"
      variant="light"
      color="blue"
      title="Get in Touch!"
      icon={<IconMail />}
    >
      Please mail us at{" "}
      <Anchor href="mailto:support@photovortex.com">
        support@photovortex.com
      </Anchor>
      !
    </Alert>
  </Container>
);

export default Contact;
